



















import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherHamburger from '../TedsLauncherHamburger/TedsLauncherHamburger.vue'
@Component({
  components: {
    TedsLauncherHamburger,
  },
})
export default class TedsLauncherProfileSection extends Vue {}
